<template>
  <button
    class="pagination-btn"
    @click="passPageNumberToParent"
  >
    {{ pageNumber }}
  </button>
</template>

<script>
export default {
  name: 'PaginationButton',
  props: {
    pageNumber: {
      type: Number,
      default: 0
    }
  },
  methods: {
    passPageNumberToParent () {
      this.$emit('getPageNumber', this.pageNumber)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped lang="scss">
.pagination-btn {
  outline: none;
}
</style>
